import { useEffect, useState } from 'react';

// Listens to window online/offline events and renders a thin amber banner when
// the browser reports offline. Worker writes will queue locally if the
// browser keeps the request in-flight; if not, the recovery panel surfaces
// the unsynced rows on next reconnect.

export function OfflineBanner() {
  const [online, setOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);

  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener('online', up);
    window.addEventListener('offline', down);
    return () => {
      window.removeEventListener('online', up);
      window.removeEventListener('offline', down);
    };
  }, []);

  if (online) return null;

  return (
    <div
      role="status"
      className="bg-signal-amber px-4 py-1.5 text-center font-mono text-[0.7rem] uppercase tracking-[0.18em] text-surface"
    >
      Offline — writes will sync when you're back.
    </div>
  );
}
